import cn from 'classnames';
import * as React from 'react';
import { memo, useMemo } from 'react';
import css from './WidgetTrigger.module.scss';
var classNames = {
    middle_left: css.trigger_middleLeft,
    middle_right: css.trigger_middleRight,
};
export var WidgetTrigger = memo(function (_a) {
    var position = _a.position, className = _a.className, children = _a.children, onClick = _a.onClick, theme = _a.theme;
    var style = useMemo(function () { return ({
        color: theme.fgColor,
        background: theme.bgColor,
    }); }, [theme]);
    return (React.createElement("div", { className: cn(css.trigger, classNames[position], className), style: style, onClick: onClick }, children));
});
//# sourceMappingURL=WidgetTrigger.js.map